/*
 * @Author: liuhuazhou liuhuazhou@xiaomi.com
 * @Date: 2024-06-19 14:08:17
 * @LastEditors: liuhuazhou liuhuazhou@xiaomi.com
 * @LastEditTime: 2024-08-19 11:37:45
 * @FilePath: /RetailApp/retail-global-h5/src/pages/Home/index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import 'rmc-tabs/assets/index.css'
import HomePage from './Home/HomePage';
import '../translation'
// 零售通国际
import DownloadsPage from './RetailGlobal/Downloads';
import RetailGlobalPrivacyNoticeENUS from './RetailGlobal/Protocol/PrivacyNotice/en-US';
import RetailGlobalPrivacyNoticeIDID from './RetailGlobal/Protocol/PrivacyNotice/id-ID';
import RetailGlobalUserAgreementENUS from './RetailGlobal/Protocol/UserAgreement/en-US';
import RetailGlobalUserAgreementIDID from './RetailGlobal/Protocol/UserAgreement/id-ID';

import RetailGlobalPrivacyCollectHKDirect from './RetailGlobal/Protocol/PrivacyCollect/hk/direct';
import RetailGlobalPrivacyCollectHKAuth from './RetailGlobal/Protocol/PrivacyCollect/hk/auth';
import RetailGlobalPrivacyCollectKRAuth from './RetailGlobal/Protocol/PrivacyCollect/kr/auth';
import RetailGlobalPrivacyCollectHKDirectCare from './RetailGlobal/Protocol/PrivacyCollect/hk/directCare';
import RetailGlobalPrivacyCollectHKDirectCPSCare from './RetailGlobal/Protocol/PrivacyCollect/hk/directCPSCare';
import RetailGlobalPrivacyCollectKZDirect from './RetailGlobal/Protocol/PrivacyCollect/kz/direct';
import RetailGlobalPrivacyCollectJPDirect from './RetailGlobal/Protocol/PrivacyCollect/jp/direct';
import RetailGlobalPrivacyCollectJPDirectCare from './RetailGlobal/Protocol/PrivacyCollect/jp/directCare';
import RetailGlobalPrivacyCollectJPDirectCPSCare from './RetailGlobal/Protocol/PrivacyCollect/jp/directCPSCare';
import RetailGlobalPrivacyCollectPLDirect from './RetailGlobal/Protocol/PrivacyCollect/pl/direct';
import RetailGlobalPrivacyCollectSGDirect from './RetailGlobal/Protocol/PrivacyCollect/sg/direct';
import RetailGlobalPrivacyCollectSGDirectCare from './RetailGlobal/Protocol/PrivacyCollect/sg/directCare';
import RetailGlobalPrivacyCollectSGDirectCPSCare from './RetailGlobal/Protocol/PrivacyCollect/sg/directCPSCare';
import RetailGlobalPrivacyCollectMYDirect from './RetailGlobal/Protocol/PrivacyCollect/my/direct';
import RetailGlobalPrivacyCollectMYDirectCare from './RetailGlobal/Protocol/PrivacyCollect/my/directCare';
import RetailGlobalPrivacyCollectMYDirectCPSCare from './RetailGlobal/Protocol/PrivacyCollect/my/directCPSCare';
import RetailGlobalPrivacyCollectKODirect from './RetailGlobal/Protocol/PrivacyCollect/ko/direct';
import RetailGlobalPrivacyCollectESDirect from './RetailGlobal/Protocol/PrivacyCollect/es/direct';
import RetailGlobalPrivacyCollectTWDirect from './RetailGlobal/Protocol/PrivacyCollect/tw/direct';
import RetailGlobalPrivacyCollectCZDirect from './RetailGlobal/Protocol/PrivacyCollect/cz/direct';
import RetailGlobalPrivacyCollectFRDirect from './RetailGlobal/Protocol/PrivacyCollect/fr/direct';
import RetailGlobalPrivacyCollectDEDirect from './RetailGlobal/Protocol/PrivacyCollect/de/direct';
import RetailGlobalPrivacyCollectMXDirect from './RetailGlobal/Protocol/PrivacyCollect/mx/direct';
import RetailGlobalPrivacyCollectVNDirect from './RetailGlobal/Protocol/PrivacyCollect/vn/direct';
import RetailGlobalPrivacyCollectMADirect from './RetailGlobal/Protocol/PrivacyCollect/ma/direct';
import RetailGlobalPrivacyCollectRODirect from './RetailGlobal/Protocol/PrivacyCollect/ro/direct';
import RetailGlobalPrivacyCollectCODirect from './RetailGlobal/Protocol/PrivacyCollect/co/direct';
import RetailGlobalPrivacyCollectGBDirect from './RetailGlobal/Protocol/PrivacyCollect/gb/direct';
import RetailGlobalPrivacyCollectIDDirect from './RetailGlobal/Protocol/PrivacyCollect/id/direct';
import RetailGlobalPrivacyCollectIDDirectCare from './RetailGlobal/Protocol/PrivacyCollect/id/directCare';
import RetailGlobalPrivacyCollectIDDirectCPSCare from './RetailGlobal/Protocol/PrivacyCollect/id/directCPSCare';

// 零售通国际预售
import RetailGlobalPreSellPrivacyCollectSGDirect from './RetailGlobal/Protocol/PresellPrivacyCollect/sg/direct';
import RetailGlobalPreSellPrivacyCollectSGAuthorization from './RetailGlobal/Protocol/PresellPrivacyCollect/sg/authorization';
import RetailGlobalPreSellPrivacyCollectPLDirect from './RetailGlobal/Protocol/PresellPrivacyCollect/pl/direct';
import RetailGlobalPreSellPrivacyCollectHKDirect from './RetailGlobal/Protocol/PresellPrivacyCollect/hk/direct';
import RetailGlobalPreSellPrivacyCollectHKAuthorization from './RetailGlobal/Protocol/PresellPrivacyCollect/hk/authorization';
import RetailGlobalPreSellPrivacyCollectJPDirect from './RetailGlobal/Protocol/PresellPrivacyCollect/jp/direct';
import RetailGlobalPreSellPrivacyCollectJPAuthorization from './RetailGlobal/Protocol/PresellPrivacyCollect/jp/authorization';

// 零售通国际-预售加载保险
import RetailGlobalPrivacyCollectAndPresellHKDirect from './RetailGlobal/Protocol/PrivacyCollectAndPresell/hk/direct';
import RetailGlobalPrivacyCollectAndPresellJPDirect from './RetailGlobal/Protocol/PrivacyCollectAndPresell/jp/direct';
import RetailGlobalPrivacyCollectAndPresellIDDirect from './RetailGlobal/Protocol/PrivacyCollectAndPresell/id/direct';
import RetailGlobalPrivacyCollectAndPresellSGDirect from "./RetailGlobal/Protocol/PrivacyCollectAndPresell/sg/direct";

// 捷克
import RetailGlobalPreSellPrivacyCollectCZDirect from './RetailGlobal/Protocol/PresellPrivacyCollect/cz/direct';
import RetailGlobalPreSellPrivacyCollectCZAuthorization from './RetailGlobal/Protocol/PresellPrivacyCollect/cz/authorization';
// 台湾
import RetailGlobalPreSellPrivacyCollectTWDirect from './RetailGlobal/Protocol/PresellPrivacyCollect/tw/direct';
import RetailGlobalPreSellPrivacyCollectTWAuthorization from './RetailGlobal/Protocol/PresellPrivacyCollect/tw/authorization';
// 哈萨克
import RetailGlobalPreSellPrivacyCollectKZDirect from './RetailGlobal/Protocol/PresellPrivacyCollect/kz/direct';
import RetailGlobalPreSellPrivacyCollectKZAuthorization from './RetailGlobal/Protocol/PresellPrivacyCollect/kz/authorization';
// 韩国
import RetailGlobalPreSellPrivacyCollectKRDirect from './RetailGlobal/Protocol/PresellPrivacyCollect/kr/direct';
import RetailGlobalPreSellPrivacyCollectKRAuthorization from './RetailGlobal/Protocol/PresellPrivacyCollect/kr/authorization';
// 越南
import RetailGlobalPreSellPrivacyCollectVNDirect from './RetailGlobal/Protocol/PresellPrivacyCollect/vn/direct';
import RetailGlobalPreSellPrivacyCollectVNAuthorization from './RetailGlobal/Protocol/PresellPrivacyCollect/vn/authorization';
// 哥伦比亚
import RetailGlobalPreSellPrivacyCollectCOLDirect from './RetailGlobal/Protocol/PresellPrivacyCollect/co/direct';
// 德国
import RetailGlobalPreSellPrivacyCollectDEDirect from './RetailGlobal/Protocol/PresellPrivacyCollect/de/direct';
// 西班牙
import RetailGlobalPreSellPrivacyCollectESDirect from './RetailGlobal/Protocol/PresellPrivacyCollect/es/direct';
// 法国
import RetailGlobalPreSellPrivacyCollectFRDirect from './RetailGlobal/Protocol/PresellPrivacyCollect/fr/direct';
// 英国
import RetailGlobalPreSellPrivacyCollectGBDirect from './RetailGlobal/Protocol/PresellPrivacyCollect/gb/direct';
// 摩洛哥
import RetailGlobalPreSellPrivacyCollectMADirect from './RetailGlobal/Protocol/PresellPrivacyCollect/ma/direct';
// 墨西哥
import RetailGlobalPreSellPrivacyCollectMXDirect from './RetailGlobal/Protocol/PresellPrivacyCollect/mx/direct';
// 罗马尼亚
import RetailGlobalPreSellPrivacyCollectRODirect from './RetailGlobal/Protocol/PresellPrivacyCollect/ro/direct';

// 零售通，RMS培训 语音检核 语音作答同意书 by 国家
import RetailGlobalVoiceRecordingConsent from './RetailGlobal/Protocol/VoiceRecordingConsent';

// 零售通国际-分期
import RetailGlobalPayUPrivacyCollectDirect from './RetailGlobal/Protocol/PayUPrivacyCollect/direct';
import RetailGlobalPayUPrivacyCollectAuth from './RetailGlobal/Protocol/PayUPrivacyCollect/auth';

// Channel 分销通
import ChannelPage from './Channel/Downloads';
import ProtocolENUS from './Channel/protocol/en-US';
import ProtocolZHCN from './Channel/protocol/zh-CN';
import ProtocolID from './Channel/protocol/id-ID';
import ProtocolZHTW from './Channel/protocol/zh-TW';
import ProtocolTHTH from './Channel/protocol/th-TH';
import ProtocolESES from './Channel/protocol/es-ES';
import ProtocolFRFR from './Channel/protocol/fr-FR';
import ProtocolDPA from './Channel/protocol/DPA';
import ProtocolDPAZHTW from './Channel/protocol/DPA/zh-TW';
import ProtocolDPAUS from './Channel/protocol/DPA/en-US';
import ProtocolDPAID from './Channel/protocol/DPA/id-ID';
import ProtocolDPATH from './Channel/protocol/DPA/th-TH';
import ProtocolDPAES from './Channel/protocol/DPA/es-ES';
import ProtocolDPAFR from './Channel/protocol/DPA/fr-FR';

// RMS 融合
import RMSDownload from './RMS/Downloads';
import RMSProtocolTCEN from './RMS/protocol/TC/en-US/index';
import RMSProtocolTCENPrivacyNotice from './RMS/protocol/TC/en-US/privacyNotice/index';

// 国际考试声明
import RMSStatementExamRoutes from './RMS/statement/exam/routes';
// CPS页面
import CPSPage from './RetailGlobal/CPS';

// 签到
import SignIn from './RMS/SignIn';

import './global.less';
import * as Sentry from "@sentry/browser";

Sentry.init({
  dsn: "https://b2d8a844f5e14b79ad519644c553d6fc@sentry.d.xiaomi.net/1439",
  integrations: [Sentry.browserTracingIntegration()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,

  // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [],
});

function App() {
  return (
    <Routes>
      <Route path='/' element={<HomePage />} />
      <Route path='/RetailGlobal/Downloads' element={<DownloadsPage />} />
      <Route path='/RetailGlobal/Protocol/PrivacyNotice' element={<RetailGlobalPrivacyNoticeENUS />} />
      <Route path='/RetailGlobal/Protocol/PrivacyNotice/en-US' element={<RetailGlobalPrivacyNoticeENUS />} />
      <Route path='/RetailGlobal/Protocol/PrivacyNotice/id-ID' element={<RetailGlobalPrivacyNoticeIDID />} />
      <Route path='/RetailGlobal/Protocol/UserAgreement' element={<RetailGlobalUserAgreementENUS />} />
      <Route path='/RetailGlobal/Protocol/UserAgreement/en-US' element={<RetailGlobalUserAgreementENUS />} />
      <Route path='/RetailGlobal/Protocol/UserAgreement/id-ID' element={<RetailGlobalUserAgreementIDID />} />

      <Route path='/RetailGlobal/Protocol/PrivacyCollect/hk/direct' element={<RetailGlobalPrivacyCollectHKDirect />} />
      <Route path='/RetailGlobal/Protocol/PrivacyCollect/hk/auth' element={<RetailGlobalPrivacyCollectHKAuth />} />
      <Route path='/RetailGlobal/Protocol/PrivacyCollect/kr/auth' element={<RetailGlobalPrivacyCollectKRAuth />} />
      <Route path='/RetailGlobal/Protocol/PrivacyCollect/hk/directCare' element={<RetailGlobalPrivacyCollectHKDirectCare />} />
      <Route path='/RetailGlobal/Protocol/PrivacyCollect/hk/directCPSCare' element={<RetailGlobalPrivacyCollectHKDirectCPSCare />} />
      <Route path='/RetailGlobal/Protocol/PrivacyCollect/kz/direct' element={<RetailGlobalPrivacyCollectKZDirect />} />
      <Route path='/RetailGlobal/Protocol/PrivacyCollect/jp/direct' element={<RetailGlobalPrivacyCollectJPDirect />} />
      <Route path='/RetailGlobal/Protocol/PrivacyCollect/jp/directCare' element={<RetailGlobalPrivacyCollectJPDirectCare />} />
      <Route path='/RetailGlobal/Protocol/PrivacyCollect/jp/directCPSCare' element={<RetailGlobalPrivacyCollectJPDirectCPSCare />} />
      <Route path='/RetailGlobal/Protocol/PrivacyCollect/sg/direct' element={<RetailGlobalPrivacyCollectSGDirect />} />
      <Route path='/RetailGlobal/Protocol/PrivacyCollect/sg/directCare' element={<RetailGlobalPrivacyCollectSGDirectCare />} />
      <Route path='/RetailGlobal/Protocol/PrivacyCollect/sg/directCPSCare' element={<RetailGlobalPrivacyCollectSGDirectCPSCare />} />
      <Route path='/RetailGlobal/Protocol/PrivacyCollect/my/direct' element={<RetailGlobalPrivacyCollectMYDirect />} />
      <Route path='/RetailGlobal/Protocol/PrivacyCollect/my/directCare' element={<RetailGlobalPrivacyCollectMYDirectCare />} />
      <Route path='/RetailGlobal/Protocol/PrivacyCollect/my/directCPSCare' element={<RetailGlobalPrivacyCollectMYDirectCPSCare />} />
      <Route path='/RetailGlobal/Protocol/PrivacyCollect/pl/direct' element={<RetailGlobalPrivacyCollectPLDirect />} />
      <Route path='/RetailGlobal/Protocol/PrivacyCollect/ko/direct' element={<RetailGlobalPrivacyCollectKODirect />} />
      <Route path='/RetailGlobal/Protocol/PrivacyCollect/es/direct' element={<RetailGlobalPrivacyCollectESDirect />} />
      <Route path='/RetailGlobal/Protocol/PrivacyCollect/tw/direct' element={<RetailGlobalPrivacyCollectTWDirect />} />
      <Route path='/RetailGlobal/Protocol/PrivacyCollect/cz/direct' element={<RetailGlobalPrivacyCollectCZDirect />} />
      <Route path='/RetailGlobal/Protocol/PrivacyCollect/fr/direct' element={<RetailGlobalPrivacyCollectFRDirect />} />
      <Route path='/RetailGlobal/Protocol/PrivacyCollect/de/direct' element={<RetailGlobalPrivacyCollectDEDirect />} />
      <Route path='/RetailGlobal/Protocol/PrivacyCollect/mx/direct' element={<RetailGlobalPrivacyCollectMXDirect />} />
      <Route path='/RetailGlobal/Protocol/PrivacyCollect/vn/direct' element={<RetailGlobalPrivacyCollectVNDirect />} />
      <Route path='/RetailGlobal/Protocol/PrivacyCollect/ma/direct' element={<RetailGlobalPrivacyCollectMADirect />} />
      <Route path='/RetailGlobal/Protocol/PrivacyCollect/ro/direct' element={<RetailGlobalPrivacyCollectRODirect />} />
      <Route path='/RetailGlobal/Protocol/PrivacyCollect/co/direct' element={<RetailGlobalPrivacyCollectCODirect />} />
      <Route path='/RetailGlobal/Protocol/PrivacyCollect/gb/direct' element={<RetailGlobalPrivacyCollectGBDirect />} />
      <Route path='/RetailGlobal/Protocol/PrivacyCollect/id/direct' element={<RetailGlobalPrivacyCollectIDDirect />} />
      <Route path='/RetailGlobal/Protocol/PrivacyCollect/id/directCare' element={<RetailGlobalPrivacyCollectIDDirectCare />} />
      <Route path='/RetailGlobal/Protocol/PrivacyCollect/id/directCPSCare' element={<RetailGlobalPrivacyCollectIDDirectCPSCare />} />


      {/* 零售通国际预售 */}
      <Route path='/RetailGlobal/Protocol/PresellPrivacyCollect/sg/direct' element={<RetailGlobalPreSellPrivacyCollectSGDirect />} />
      <Route path='/RetailGlobal/Protocol/PresellPrivacyCollect/sg/authorization' element={<RetailGlobalPreSellPrivacyCollectSGAuthorization />} />
      <Route path='/RetailGlobal/Protocol/PresellPrivacyCollect/pl/direct' element={<RetailGlobalPreSellPrivacyCollectPLDirect />} />
      <Route path='/RetailGlobal/Protocol/PresellPrivacyCollect/hk/direct' element={<RetailGlobalPreSellPrivacyCollectHKDirect />} />
      <Route path='/RetailGlobal/Protocol/PresellPrivacyCollect/hk/authorization' element={<RetailGlobalPreSellPrivacyCollectHKAuthorization />} />
      <Route path='/RetailGlobal/Protocol/PresellPrivacyCollect/jp/direct' element={<RetailGlobalPreSellPrivacyCollectJPDirect />} />
      <Route path='/RetailGlobal/Protocol/PresellPrivacyCollect/jp/authorization' element={<RetailGlobalPreSellPrivacyCollectJPAuthorization />} />
      <Route path='/RetailGlobal/Protocol/PresellPrivacyCollect/cz/direct' element={<RetailGlobalPreSellPrivacyCollectCZDirect />} />
      <Route path='/RetailGlobal/Protocol/PresellPrivacyCollect/cz/authorization' element={<RetailGlobalPreSellPrivacyCollectCZAuthorization />} />
      <Route path='/RetailGlobal/Protocol/PresellPrivacyCollect/tw/direct' element={<RetailGlobalPreSellPrivacyCollectTWDirect />} />
      <Route path='/RetailGlobal/Protocol/PresellPrivacyCollect/tw/authorization' element={<RetailGlobalPreSellPrivacyCollectTWAuthorization />} />
      <Route path='/RetailGlobal/Protocol/PresellPrivacyCollect/kz/direct' element={<RetailGlobalPreSellPrivacyCollectKZDirect />} />
      <Route path='/RetailGlobal/Protocol/PresellPrivacyCollect/kz/authorization' element={<RetailGlobalPreSellPrivacyCollectKZAuthorization />} />
      <Route path='/RetailGlobal/Protocol/PresellPrivacyCollect/kr/direct' element={<RetailGlobalPreSellPrivacyCollectKRDirect />} />
      <Route path='/RetailGlobal/Protocol/PresellPrivacyCollect/kr/authorization' element={<RetailGlobalPreSellPrivacyCollectKRAuthorization />} />
      <Route path='/RetailGlobal/Protocol/PresellPrivacyCollect/vn/direct' element={<RetailGlobalPreSellPrivacyCollectVNDirect />} />
      <Route path='/RetailGlobal/Protocol/PresellPrivacyCollect/vn/authorization' element={<RetailGlobalPreSellPrivacyCollectVNAuthorization />} />
      <Route path='/RetailGlobal/Protocol/PresellPrivacyCollect/co/direct' element={<RetailGlobalPreSellPrivacyCollectCOLDirect />} />
      <Route path='/RetailGlobal/Protocol/PresellPrivacyCollect/de/direct' element={<RetailGlobalPreSellPrivacyCollectDEDirect />} />
      <Route path='/RetailGlobal/Protocol/PresellPrivacyCollect/es/direct' element={<RetailGlobalPreSellPrivacyCollectESDirect />} />
      <Route path='/RetailGlobal/Protocol/PresellPrivacyCollect/fr/direct' element={<RetailGlobalPreSellPrivacyCollectFRDirect />} />
      <Route path='/RetailGlobal/Protocol/PresellPrivacyCollect/gb/direct' element={<RetailGlobalPreSellPrivacyCollectGBDirect />} />
      <Route path='/RetailGlobal/Protocol/PresellPrivacyCollect/ma/direct' element={<RetailGlobalPreSellPrivacyCollectMADirect />} />
      <Route path='/RetailGlobal/Protocol/PresellPrivacyCollect/mx/direct' element={<RetailGlobalPreSellPrivacyCollectMXDirect />} />
      <Route path='/RetailGlobal/Protocol/PresellPrivacyCollect/ro/direct' element={<RetailGlobalPreSellPrivacyCollectRODirect />} />
      <Route path='/RetailGlobal/Protocol/PayUPrivacyCollect/Direct' element={<RetailGlobalPayUPrivacyCollectDirect />} />
      <Route path='/RetailGlobal/Protocol/PayUPrivacyCollect/Auth' element={<RetailGlobalPayUPrivacyCollectAuth />} />
      <Route path='/RetailGlobal/Protocol/VoiceRecordingConsent/:country?' element={<RetailGlobalVoiceRecordingConsent />} />
      <Route path="/ChannelPage/Downloads" element={<ChannelPage />} />
      <Route path="/ChannelPage/protocol/en-US" element={<ProtocolENUS />} />
      <Route path="/ChannelPage/protocol/zh-CN" element={<ProtocolZHCN />} />
      <Route path="/ChannelPage/protocol/id-ID" element={<ProtocolID />} />
      <Route path="/ChannelPage/protocol/zh-TW" element={<ProtocolZHTW />} />
      <Route path="/ChannelPage/protocol/ar-SA" element={<ProtocolENUS />} />
      <Route path="/ChannelPage/protocol/ha-NG" element={<ProtocolENUS />} />
      <Route path="/ChannelPage/protocol/th-TH" element={<ProtocolTHTH />} />
      <Route path="/ChannelPage/protocol/es-ES" element={<ProtocolESES />} />
      <Route path="/ChannelPage/protocol/fr-FR" element={<ProtocolFRFR />} />
      <Route path="/ChannelPage/protocol/DPA" element={<ProtocolDPA />} />
      <Route path="/ChannelPage/protocol/DPA/zh-TW" element={<ProtocolDPAZHTW />} />
      <Route path="/ChannelPage/protocol/DPA/en-US" element={<ProtocolDPAUS />} />
      <Route path="/ChannelPage/protocol/DPA/id-ID" element={<ProtocolDPAID />} />
      <Route path="/ChannelPage/protocol/DPA/zh-CN" element={<ProtocolDPAUS />} />
      <Route path="/ChannelPage/protocol/DPA/ar-SA" element={<ProtocolDPAUS />} />
      <Route path="/ChannelPage/protocol/DPA/ha-NG" element={<ProtocolDPAUS />} />
      <Route path="/ChannelPage/protocol/DPA/th-TH" element={<ProtocolDPATH />} />
      <Route path="/ChannelPage/protocol/DPA/es-ES" element={<ProtocolDPAES />} />
      <Route path="/ChannelPage/protocol/DPA/fr-FR" element={<ProtocolDPAFR />} />

      <Route path='/RetailGlobal/Protocol/PrivacyCollectAndPresell/hk/direct' element={<RetailGlobalPrivacyCollectAndPresellHKDirect />} />
      <Route path='/RetailGlobal/Protocol/PrivacyCollectAndPresell/jp/direct' element={<RetailGlobalPrivacyCollectAndPresellJPDirect />} />
      <Route path='/RetailGlobal/Protocol/PrivacyCollectAndPresell/id/direct' element={<RetailGlobalPrivacyCollectAndPresellIDDirect />} />
      <Route path='/RetailGlobal/Protocol/PrivacyCollectAndPresell/sg/direct' element={<RetailGlobalPrivacyCollectAndPresellSGDirect />} />

      <Route path="/RMS/Downloads" element={<RMSDownload />} />
      <Route path="/RMS/protocol/tc/en-US" element={<RMSProtocolTCEN />} />
      <Route path="/RMS/protocol/tc/en-US/privacyNotice" element={<RMSProtocolTCENPrivacyNotice />} />

      {/* 国际考试声明（提取子路由） */}
      <Route path="/RMS/statement/exam/*" element={<RMSStatementExamRoutes />} />

      {/* 扫码签到 */}
      <Route path="/RMS/signIn" element={<SignIn />} />

      {/* CPS订单查询页面 */}
      <Route path="/RetailGlobal/CPS" element={<CPSPage />} />
    </Routes>
  );
}

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter basename='/'>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);
const rootDom = document.getElementById('root')
if (rootDom) {
  rootDom.style.height = '100%';
  rootDom.style.maxWidth = '540px';
  rootDom.style.flex = '1';
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
